import { useParams } from 'react-router-dom';
import PublicProfile from './PublicProfile';
import DeeplinkRedirect from './DeeplinkRedirect';

const DynamicRoute = () => {
  const { param } = useParams<{ param: string }>();

  if (!param) return null;

  if (param.startsWith('@')) {
    return <PublicProfile username={param.slice(1)} />;
  }

  return <DeeplinkRedirect code={param} />;
};

export default DynamicRoute;
